@if ({ site_announcement: selectedSiteAnnouncements$ | async }; as obs) {
  <div class="create-site-dialog-container">
    <div class="gb-dialog-header">
      <h1>{{ (obs.site_announcement ? 'SITE_ANNOUNCEMENTS.EDIT' : 'SITE_ANNOUNCEMENTS.CREATE') | translate }}</h1>
      <button mat-icon-button mat-dialog-close>
        <gb-icon icon="close"></gb-icon>
      </button>
    </div>
    <div class="gb-dialog-content">
      <form [formGroup]="createSiteFormGroup">
        <gb-form-field [control]="title" labelTranslateKey="SITE_ANNOUNCEMENTS.TABLE.TITLE"></gb-form-field>
        <gb-form-field [control]="preamble" labelTranslateKey="SITE_ANNOUNCEMENTS.DIALOG.PREVIEW"></gb-form-field>
        <div #siteAnnoncementQuillContainer>
          <gb-quill-editor
            [bounds]="siteAnnoncementQuillContainer"
            class="site-quill-editor"
            [formControl]="content"
          ></gb-quill-editor>
        </div>
        <gb-select-form-field
          [control]="target"
          [options$]="targetOptions$"
          displayProperty="name"
          valueProperty="value"
          labelTranslateKey="SITE_ANNOUNCEMENTS.TABLE.TARGET"
        ></gb-select-form-field>
        <mat-checkbox [formControl]="display">{{ 'SITE_ANNOUNCEMENTS.TABLE.DISPLAY' | translate }}</mat-checkbox>
        <gb-datetime-form-field
          formControlName="publish_date"
          labelTranslateKey="SITE_ANNOUNCEMENTS.TABLE.PUBLISH_DATE"
        ></gb-datetime-form-field>
        <gb-datetime-form-field
          formControlName="display_until"
          labelTranslateKey="SITE_ANNOUNCEMENTS.TABLE.DISPLAY_UNTIL"
        ></gb-datetime-form-field>
      </form>
    </div>
    <div class="gb-dialog-actions-container">
      <button mat-flat-button type="submit" (click)="submit(obs.site_announcement)">
        <gb-button-loader [loaded$]="editCreateLoaded$">
          <span>{{ 'SAVE' | translate }}</span>
        </gb-button-loader>
      </button>
    </div>
  </div>
}
